import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
var styles = xcss({
  width: '100%',
  borderBlockEnd: 'none',
  borderBlockStart: "1px solid ".concat("var(--ds-border, #091E4224)"),
  borderInline: 'none'
});
export var Divider = function Divider() {
  return /*#__PURE__*/React.createElement(Box, {
    as: "hr",
    xcss: styles,
    role: "presentation"
  });
};